import { useState } from "react";
import {
  Button,
  Card,
  PasswordInput,
  Stack,
  TextInput,
  Title,
  Text,
  Center,
  Alert,
} from "@mantine/core";
import { IconAlertCircle, IconDeviceMobile } from "@tabler/icons-react";
import { useAuth } from "../../../shared/auth";

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [tenantSlug, setTenantSlug] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setError(null);
    setLoading(true);
    try {
      await login(username, password, tenantSlug || undefined, "POS");
    } catch (e: any) {
      setError(e?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Center h="100vh" bg="gray.0" p="md">
      <Card padding="xl" radius="lg" withBorder shadow="md" w="100%" maw={420}>
        <Stack gap="lg">
          <Center>
            <IconDeviceMobile size={48} color="var(--mantine-color-blue-6)" />
          </Center>
          <Stack gap={4}>
            <Title order={2} ta="center">
              Garson POS
            </Title>
            <Text c="dimmed" ta="center" size="sm">
              Kullanıcı adı ve şifrenizle giriş yapın
            </Text>
          </Stack>

          {error && (
            <Alert color="red" icon={<IconAlertCircle size={16} />}>
              {error}
            </Alert>
          )}

          <TextInput
            label="Kullanıcı Adı"
            value={username}
            onChange={(e) => setUsername(e.currentTarget.value)}
            size="md"
            autoFocus
          />
          <PasswordInput
            label="Şifre"
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            size="md"
          />
          <TextInput
            label="Restoran Kodu (ops.)"
            value={tenantSlug}
            onChange={(e) => setTenantSlug(e.currentTarget.value)}
            size="md"
          />

          <Button size="lg" onClick={handleSubmit} loading={loading} fullWidth>
            Giriş Yap
          </Button>
        </Stack>
      </Card>
    </Center>
  );
}
